"use client";

import { useEffect, useState } from "react";

import { getUserAgreeCookies } from "@/services/cookies/user-info.service";

import { CookiesInfo } from "../../CookiesInfo";

import styles from "./style.module.scss";

export const InfoContainer = () => {
  const [isAgree, setIsAgree] = useState<string | null>(null);

  useEffect(() => {
    const consent = getUserAgreeCookies();
    setIsAgree(consent);
  }, []);

  if (isAgree === "true" || isAgree === null) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <CookiesInfo agreeCookies={setIsAgree} />
    </div>
  );
};
